import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Edit, Package, Tag } from 'lucide-react';
import { produits as produitsData, categoriesProduits, getCategorieById } from '../../data/mockData';

function ListeProduits({ user }) {
  const [produits, setProduits] = useState(produitsData);
  const [searchTerm, setSearchTerm] = useState('');
  const [filtreCategorie, setFiltreCategorie] = useState('tous');

  const filteredProduits = produits.filter(produit => {
    const matchSearch = produit.nom.toLowerCase().includes(searchTerm.toLowerCase());
    const matchCategorie = filtreCategorie === 'tous' || produit.categorieId === parseInt(filtreCategorie);
    return matchSearch && matchCategorie;
  });

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>Produits</h1>
          <p className="text-muted">Gestion des produits</p>
        </div>
        {user.role === 'admin' && (
          <Link to="/produits/nouveau" className="btn btn-primary">
            <Plus size={20} />
            Ajouter un produit
          </Link>
        )}
      </div>

      <div className="filters-bar">
        <input
          type="text"
          placeholder="Rechercher un produit..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />

        <select
          value={filtreCategorie}
          onChange={(e) => setFiltreCategorie(e.target.value)}
          className="filter-select"
        >
          <option value="tous">Toutes les catégories</option>
          {categoriesProduits.map(cat => (
            <option key={cat.id} value={cat.id}>{cat.nom}</option>
          ))}
        </select>
      </div>

      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Nom</th>
              <th>Catégorie</th>
              <th>Unité</th>
              <th>Seuil d'alerte</th>
              <th>Statut</th>
              {user.role === 'admin' && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {filteredProduits.map(produit => {
              const categorie = getCategorieById(produit.categorieId);
              
              return (
                <tr key={produit.id}>
                  <td>
                    <div className="flex items-center gap-2">
                      <Package size={16} className="icon-muted" />
                      <strong>{produit.nom}</strong>
                    </div>
                  </td>
                  <td>
                    <span className="badge badge-secondary">
                      {categorie?.nom}
                    </span>
                  </td>
                  <td>{produit.unite}</td>
                  <td>
                    <span className="text-warning">
                      ≤ {produit.seuilAlerte} {produit.unite}
                    </span>
                  </td>
                  <td>
                    <span className={`badge ${produit.actif ? 'badge-success' : 'badge-secondary'}`}>
                      {produit.actif ? 'Actif' : 'Inactif'}
                    </span>
                  </td>
                  {user.role === 'admin' && (
                    <td>
                      <Link
                        to={`/produits/${produit.id}/modifier`}
                        className="btn btn-sm btn-secondary"
                      >
                        <Edit size={16} />
                      </Link>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {filteredProduits.length === 0 && (
        <div className="empty-state">
          <Package size={48} className="icon-muted" />
          <p>Aucun produit trouvé</p>
        </div>
      )}
    </div>
  );
}

export default ListeProduits;

